const publicUrl = process.env.PUBLIC_URL
export const smigLogo = `${publicUrl}/smig_logo.png`
export const smigError = `${publicUrl}/smig_err.png`
export const smigBg = `${publicUrl}/smig_bg.jpeg`
